// Detail page of each request type
export const DETAIL_PAGES = {
  RegistrationRequest: "/operator/business-creation-detail",
  CriminalRecordRequest: "/operator/criminal-record-detail",
  NationalityCertificateRequest: "/operator/certificate-nationality-detail",
  CelibacyCertificateRequest: "/operator/certificate-singleness-detail",
  EneoRequest: "/operator/eneo-detail",
  CustomsRebateRequest: "/operator/customs-rebate-detail",
  BusinessPlanRequest: "/operator/business-plan-detail",
  ImportationRequest: "/operator/importation-detail",
  OapiRequest: "/operator/oapi-detail",
  PassportEnrollmentRequest: "/operator/passport-detail",
  VisualIdentityRequest: "/operator/visual-identity-detail",
  TrademarkRequest: "/operator/formality-detail",
  TaxRegistrationRequest: "/operator/formality-detail",
  TaxComplianceRequest: "/operator/formality-detail",
  CnpsRegistrationRequest: "/operator/formality-detail",
};

// Router state expected by the detail pages
export const detailState = (request) =>
  request.type === "RegistrationRequest"
    ? { businessCreation: request }
    : { procedure: request };

// Operator page of each service, for the requests made to our teams
export const SERVICE_PAGES = [
  {
    code: "domiciliation",
    label: "Domiciliation",
    path: "/operator/domiciliation",
  },
  { code: "admin", label: "Administration", path: "/operator/platformAdmin" },
  {
    code: "juridique",
    label: "Suivi juridique",
    path: "/operator/platformJuridique",
  },
  { code: "management", label: "Facturation", path: "/operator/platformGest" },
  { code: "grh", label: "Ressources humaines", path: "/operator/platformGRH" },
  { code: "sales", label: "Relation client", path: "/operator/platformSale" },
  {
    code: "odoo",
    label: "Comptes ERP",
    path: "/operator/odoo-tickets",
  },
];
